module.exports = __webpack_public_path__ + "media/images/ic_massages_soins-bf20502485875679cf8e177d3b554fc4.svg";